import React from 'react'
import type { ReactNode } from 'react'
import { Routes, Navigate, Route } from 'react-router-dom'

export type RouteItemsProps = {
  config: RouteItemProps[]
}

export type RouteItemProps = {
  path?: string
  name?: string
  redirect?: string
  element?: ReactNode
  children?: RouteItemProps[]
}

function RouteItems(props: RouteItemsProps): JSX.Element {
  const { config } = props

  const renderRouteItem = (route: RouteItemProps): JSX.Element => {
    const { path, name, redirect, element, children } = route

    if (redirect) {
      return (
        <Route
          key={name}
          path={path}
          element={<Navigate replace to={redirect} />}
        />
      )
    } else if (children && children.length > 0) {
      return (
        <Route key={name} path={path} element={element}>
          {renderRouteItems(children)}
        </Route>
      )
    }

    return <Route key={name} path={path} element={element} />
  }

  const renderRouteItems = (routes: RouteItemProps[]): JSX.Element[] => {
    return routes.map(renderRouteItem)
  }

  return <Routes>{renderRouteItems(config)}</Routes>
}

export default RouteItems
